import { render, staticRenderFns } from "./Item10.vue?vue&type=template&id=a0753ce8&scoped=true&"
import script from "./Item10.vue?vue&type=script&lang=js&"
export * from "./Item10.vue?vue&type=script&lang=js&"
import style0 from "./Item10.vue?vue&type=style&index=0&id=a0753ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0753ce8",
  null
  
)

export default component.exports